import { v4 as uuidv4 } from 'uuid';
import { EMPTY_ITEM } from 'components/order-table-row/constants';
import { EMPTY_MESSAGE } from 'constants/common';
import { QuickOrderForm } from 'services/cart/types';

export const ITEM_NOTES_MAXLENGTH = 500;
export const ERROR_MESSAGES = {
  UPC5017: 'INVALID_ITEM_ERROR',
  UPC5053: 'INVALID_ITEM_ERROR',
  UPC5018: 'QO_ERROR_UPC_5018'
};
export const QUICK_ORDER_DRAWER_WIDTH = '90%';
export const QUICK_ORDER_DRAWER_COMPACT_WIDTH = '40%';
export const SAVED_LISTS_DRAWER_WIDTH = '90%';
export const FULL_WIDTH_QO_DRAWER = '100%';
export const MILLISECONDS_DEBOUNCE_CART = 1500;
export const SELECT_ORDER_INFORMATION_FORM_ID = 'select-order-information-form';
export const CART_IMAGE_WIDTH_STANDARD = 90;
export const CART_IMAGE_WIDTH_COMPACT = 64;
export const CART_IMAGE_HEIGHT_STANDARD = 97;
export const CART_IMAGE_HEIGHT_COMPACT = 69;
export const MINIMUM_PACKAGE_QUANTITY = 2;
export const ORDERT_TYPE_EMAIL_CART = 'EmailCart';
export const NEW_CART_FEATURE_MODAL_VIEWED = 'SC_Headless_Feature_Model_Viewed';
export const SC_HEADLESS_FEATURE_FIRSTTIME_DISPLAY =
  'SC_Headless_Feature_FirstTime_Display';
export const SHOPPING_CART_ESPOT_NAME =
  'CMC_ESPOT_CARTFEATURE_SHOPPING_CART_CUSTOMIZATION_CARD_DATE';
export const CHOOSE_YOUR_VIEW_ESPOT_NAME =
  'CMC_ESPOT_CARTFEATURE_CHOOSE_YOUR_VIEW_CARD_DATE';
export const QUICK_ORDER_ESPOT_NAME =
  'CMC_ESPOT_CARTFEATURE_QUICK_ORDER_CARD_DATE';
export const SHARE_CART_ESPOT_NAME =
  'CMC_ESPOT_CARTFEATURE_SHARE_CART_CARD_DATE';
export const PARTS_AVAILABILITY_ESPOT_NAME =
  'CMC_ESPOT_CARTFEATURE_PARTS_AVAILABILITY_CARD_DATE';
export const PCC_HEADLESS_STANDARD_CART_BOTTOM_RIGHT_ESPOT =
  'CMC_ESPOT_PCC_HEADLESS_CART_BOTTOM_RIGHT';
export const ATTRIBUTE_COLSPAN_VALUE = 3;
export const ITEM_COLSPAN_VALUE = 2;
export const CART_ITEM_COLSPAN_VALUE = 1;
export const PCC_SHOPPING_CART = 'PCCShoppingCart';
export const PCC_SHOPPING_CART_LOGGEDIN = 'PCCCartLoggedIn';
export const REFRESH_PRICES = true;
export const MAX_LINE_ITEM_ERROR = 'maxLineItemError';
export const INVALID_PARTS_COOKIE = 'invalidParts';

export enum BannerVariant {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success'
}

export enum KitType {
  PMKIT = 'PMKIT',
  SSRO = 'SSRO'
}

export enum PartType {
  SOS = 'SOS',
  REPLACEMENT = 'REPLACEMENT',
  ALTERNATIVE = 'ALTERNATIVE',
  REGULAR = 'REGULAR'
}

export const CART_PAGE_BREKPOINTS = {
  BLOCKS_XXL: 1450,
  XXL: 1232,
  XL: 1200,
  BLOCKS_XL: 1024,
  LG: 992,
  BLOCKS_LG: 960,
  MD: 768,
  SM: 576,
  BLOCKS_SM: 560,
  XS: 400
};

export const quickOrderFormDefaultValues: QuickOrderForm = {
  items: [
    {
      ...EMPTY_ITEM,
      referenceId: uuidv4(),
      id: uuidv4()
    }
  ],
  message: EMPTY_MESSAGE,
  isCheckingOut: false,
  isValidationPending: false
};

export const CartStackNotifications = {
  PRICE_ISSUE_WARNING: 'PRICE_ISSUE_WARNING',
  PACKAGE_QUANTITY_ERROR: 'PACKAGE_QUANTITY_ERROR',
  INDIRECTLY_REPLACED_WARNING: 'INDIRECTLY_REPLACED_ERROR',
  INVALID_PARTS_WARNING: 'INVALID_PARTS_WARNING',
  SSO_INFO: 'SELF_SERVICE_OPTION_INFO',
  PMKITS_INFO: 'PMKITS_INFO',
  PARTS_WITH_INDIRECT_REPLACEMENT: 'PARTS_WITH_INDIRECT_REPLACEMENT'
};

export const RP_COOKIE = 'rp';

export const japanDealer = ['W611', 'W310', 'W230', 'W220'];

export const CART_ACTIONS = {
  EMPTY_CART: 'EMPTY'
};
export const SPECIAL_INST_ROW_LEN = 3;

export const promoError = [
  'Promotion code should be between 1-10 characters',
  'Promotion code is expired',
  'Promotion code has already been used'
];

export const DELIVERY_TYPES = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup',
  DROPBOX: 'dropBox'
};
